<template>
  <div class="chartBox">
    <div class="myChart" ref="myChart" :style="{ width: width, height: height }"></div>
    <ul class="legth" :style="{ top: legTop, left: legLeft }" v-if="legIsShow">
      <li v-for="(item, i) in legthWZ" :key="i">
        <h3 :style="{ backgroundColor: legthColor[i] }"></h3>
        <span>{{ item }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'pieGeRenNanDing',
  props: {
    rowData: {
      type: Array,
      default: () => {
        return [
          {
            name: '北京',
            value: 90,
            item: 10
          },
          {
            name: '上海',
            value: 80,
            item: 20
          },
          {
            name: '天津',
            value: 70,
            item: 30
          },
          {
            name: '重庆',
            value: 30,
            item: 70
          },
          {
            name: '内蒙古',
            value: 30,
            item: 70
          },
          {
            name: '江苏',
            value: 70,
            item: 30
          }
        ]
      }
    },
    barColor: {
      type: Array,
      default: () => {
        return ['#3DC2CC00', '#3DC2CC', '#FF794D00', '#FF794D']
      }
    },
    legthColor: {
      type: Array,
      default: () => {
        return ['#4BDBF4', '#EECC46']
      }
    },
    legthWZ: {
      type: Array,
      default: () => {
        return ['空间', '占用']
      }
    },
    unit: {
      type: String,
      default: () => {
        return '%'
      }
    },
    barWidth: {
      type: String,
      default: () => {
        return '20'
      }
    },
    width: {
      type: String,
      default: () => {
        return '630px'
      }
    },
    height: {
      type: String,
      default: () => {
        return '430px'
      }
    },
    legTop: {
      type: String,
      default: () => {
        return '10px'
      }
    },
    legLeft: {
      type: String,
      default: () => {
        return '200px'
      }
    },
    legIsShow: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      Xdata: [],
      Ydata: [],
      valTwo: [],
      setTime: null,
      chartInst: null
    }
  },
  mounted() {
    // this.getData();
    if (this.rowData && this.rowData.length > 0) {
      this.rowData.forEach(item => {
        this.Xdata.push(item.name)
        this.Ydata.push(item.value)
        this.valTwo.push(item.item)
      })
    }
    this.drawWidth()
    this.tooltipShuffling()
  },
  methods: {
    drawWidth() {
      // 基于准备好的dom，初始化echarts实例
      this.chartInst = this.$echarts.init(this.$refs.myChart)
      this.chartInst.setOption({
        color:this.barColor,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          icon: 'rect',
          data: this.legthWZ,
          right: '5%',
          top: '3%',
          selectedMode: true,
          borderWidth: 0,
          padding: 0,
          itemGap: 20,
          itemWidth: 20,
          itemHeight: 4,
          textStyle: {
            color: '#fff',
            fontFamily: '微软雅黑',
            fontSize: 24
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'value',
            axisTick: {
              alignWithLabel: true
            },
            max: 100,
            axisLabel: {
              //x轴文字的配置
              textStyle: {
                color: '#ccc',
                fontSize: 24,
                fontFamily: '微软雅黑'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ccc',
                width: 1.2 //这里是为了突出显示加上的
              }
            }
          }
        ],
        yAxis: [
          {
            data: this.Xdata,
            name: `单位:${this.unit}`,
            position: 'left',
            type: 'category',
            nameTextStyle: {
              color: '#ccc',
              fontSize: 24,
              padding: 2,
              fontFamily: '微软雅黑'
            },
            axisLabel: {
              //y轴文字的配置
              textStyle: {
                color: '#cccc',
                fontSize: 24,
                fontFamily: '微软雅黑'
              }
            },
            splitNumber: 5,
            // 设置y轴线条的粗细
            splitLine: {
              show: false,
              lineStyle: {
                color: ['#0A223E'],
                width: 2,
                type: 'solid'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'transparent',
                width: 0 //这里是为了突出显示加上的
              }
            },
            splitArea: {
              show: false,
              areaStyle: {
                color: ['rgba(14,29,52,0.5)', 'rgba(191,235,255,0.12)']
              }
            }
          }
        ],
        series: [
          {
            name: this.legthWZ[0],
            type: 'bar',
            stack: '广告',
            barWidth: this.barWidth,
            data: this.Ydata,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: this.barColor[0]
                  },
                  {
                    offset: 1,
                    color: this.barColor[1]
                  }
                ])
              }
            }
          },
          {
            name: this.legthWZ[1],
            type: 'bar',
            stack: '广告',
            barWidth: this.barWidth,
            data: this.valTwo,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: this.barColor[2]
                  },
                  {
                    offset: 1,
                    color: this.barColor[3]
                  }
                ])
              }
            }
          }
        ]
      })
      //设置默认选中高亮部分
      this.chartInst.dispatchAction({
        type: 'downplay',
        seriesIndex: 0,
        dataIndex: 0
      }) //鼠标进
    },
    tooltipShuffling() {
      clearInterval(this.setTime)
      var currentIndex = -1
      this.setTime = setInterval(() => {
        var dataLen = this.Ydata.length
        // 取消之前高亮的图形
        this.chartInst.dispatchAction({
          type: 'downplay',
          seriesIndex: 0, //表示series中的第几个data数据循环展示
          dataIndex: currentIndex
        })
        currentIndex = (currentIndex + 1) % dataLen //+1表示每次跳转一个
        this.chartInst.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: currentIndex
        })
        // 显示 tooltip
        this.chartInst.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: currentIndex
        })
      }, 3000)
    }
  },
  beforeDestroy() {
    clearInterval(this.setTime)
    this.setTime = null
    this.chartInst.dispose()
  },
  watch: {
    rowData: {
      handler() {
        this.Xdata = []
        this.Ydata = []
        this.valTwo = []
        this.rowData.forEach(item => {
          this.Xdata.push(item.name)
          this.Ydata.push(item.value)
          this.valTwo.push(item.item)
        })
        this.tooltipShuffling()
        this.drawWidth()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chartBox {
  position: relative;
  width: 100%;
  .legth {
    position: absolute;
    left: 321px;
    top: 10px;
    li {
      float: left;
      // width: 200px;
      height: 20px;
      margin-right: 20px;
      h3 {
        float: left;
        width: 6px;
        height: 24px;
        background-color: red;
        margin-top: 6px;
      }
      span {
        margin-left: 7px;
        font-size: 26px;
        font-family: '微软雅黑';
        color: #bfebff;
      }
    }
  }
}
</style>
